import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import React from "react";
import { FormTextField, FormCheckbox } from "../../../../../../components/fields";
import { IFormValues } from "../../../../types";

const Details = () => {

    const { t } = useTranslation('booking');

    return (
        <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="h5">
                    {t('label.details')}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container rowSpacing={1} columnSpacing={3}>
                    <Grid item xs={12} sm={3}>
                        <FormTextField<IFormValues>
                            name="substitutionDetail.reason"
                            label={t('label.eventInfo_reason')}
                            InputProps={{ readOnly: true }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormTextField<IFormValues>
                            name="substitutionDetail.eventDate"
                            label={t('label.eventInfo_eventDate')}
                            InputProps={{ readOnly: true }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormTextField<IFormValues>
                            name="substitutionDetail.eventPlaceCountry"
                            label={t('label.eventInfo_eventPlaceCountry')}
                            InputProps={{ readOnly: true }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormTextField<IFormValues>
                            name="substitutionDetail.eventPlaceProvince"
                            label={t('label.eventInfo_eventPlaceProvince')}
                            InputProps={{ readOnly: true }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormTextField<IFormValues>
                            name="substitutionDetail.eventPlaceCity"
                            label={t('label.eventInfo_eventPlaceCity')}
                            InputProps={{ readOnly: true }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormTextField<IFormValues>
                            name="substitutionDetail.eventPlacePostalCode"
                            label={t('label.eventInfo_eventPlacePostalCode')}
                            InputProps={{ readOnly: true }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormTextField<IFormValues>
                            name="substitutionDetail.eventPlaceStreetName"
                            label={t('label.eventInfo_eventPlaceStreetName')}
                            InputProps={{ readOnly: true }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormTextField<IFormValues>
                            name="substitutionDetail.eventPlaceStreetNumber"
                            label={t('label.eventInfo_eventPlaceStreetNumber')}
                            InputProps={{ readOnly: true }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormTextField<IFormValues>
                            name="substitutionDetail.eventDescription"
                            label={t('label.eventInfo_eventDescription')}
                            multiline
                            rows={2}
                            InputProps={{ readOnly: true }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}  mt={2} justifyContent="space-between" alignItems="center">
                        <FormCheckbox<IFormValues>
                            name="substitutionDetail.vehicleAvailability"
                            label={t('label.eventInfo_vehicleAvailability')}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}  mt={2} justifyContent="space-between" alignItems="center">
                        <FormCheckbox<IFormValues>
                            name="substitutionDetail.substancesInfluence"
                            label={t('label.eventInfo_substancesInfluence')}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} mt={2} justifyContent="space-between" alignItems="center">
                        <FormCheckbox<IFormValues>
                            name="substitutionDetail.policeInvolved"
                            label={t('label.eventInfo_policeInvolved')}
                            disabled={true}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormTextField<IFormValues>
                            name="substitutionDetail.notePoliceInvolved"
                            label={t('label.eventInfo_notePoliceInvolved')}
                            multiline
                            rows={2}
                            InputProps={{ readOnly: true }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
};

export default Details;
